import { render, staticRenderFns } from "./EventTabReportTable.vue?vue&type=template&id=3e8b45e5&"
import script from "./EventTabReportTable.vue?vue&type=script&lang=js&"
export * from "./EventTabReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports